import React, { useContext } from 'react';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { Main, Body, Header } from '../../NecttosComp/Layout/Layout';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import Button from '../../NecttosComp/Button/Button';
import notFoundProfile from '../../../src/static/images/library/noPhotoAvailable.png'
import Instruction from '../../Documentation/Instruction';

const getSupperVission =
	({ collegeId }) =>
		async () => {
			const instance = await getAxiosTokenInstance();
			try {
				const resp = await instance.get('/college/timetable/getTimetableOnDate', {
					params: { collegeId },
				});

				if (resp.data.statusCode === 400) {
					throw new Error(resp.data.message || 'API Error');
				} else {
					return resp?.data?.timetable;
				}
			} catch (error) {
				throw new Error(error?.response?.data?.message || error.message || 'API Error');
			}
		};

function SupperVision({ onClose }) {
	const { collegeId } = useContext(FirebaseContext);

	let { data } = useQuery(['DFCertyhgfdR0', collegeId], getSupperVission({ collegeId }));

	data = data?.sort((a, b) => a?.className?.localeCompare(b?.className));

	return (
		<Main title='Super Vision' height='100%' width='100%'>
			<Header>
				<div></div>
				<div className='flex justify-end'>
					<Instruction keyId={'supperVission'}></Instruction>
					<Button type='close' onClick={onClose}>Close</Button>
				</div>
			</Header>
			<Body>
				<div className="flex flex-wrap items-center justify-center gap-4">
					{data?.map((item, _i) => (
						<button
							key={item.key}
							className={`flex flex-col items-center gap-4 p-4 w-[200px] h-[300px] rounded-md shadow-md transition-colors
                                   ${item.attendance === 'Not-taked'
									? 'bg-red-500 dark:bg-red-700'
									: 'bg-green-500 dark:bg-green-700'} `}
						>
							<div className="flex-shrink-0">
								<img
									src={item?.periodDetail?.photoURL || notFoundProfile }
									alt="Profile"
									className="w-12 h-12 rounded-full object-cover"
								/>
							</div>
							<div className="text-left">
								<h2 className="text-white text-sm dark:text-white font-semibold">
									{item?.className} [
									{item?.periodDetail?.totalStrenght
										? (
											((item?.periodDetail?.presents || 0) /
												(item?.periodDetail?.totalStrenght || 0)) *
											100
										).toFixed(0)
										: 0}
									%]
								</h2>
								<h2 className="text-white text-sm dark:text-white">{item?.periodDetail?.name}</h2>
								<h2 className="text-white text-sm dark:text-white">
									{item?.periodDetail?.subjectDetails?.name.slice(0, 20)}
								</h2>
							</div>
						</button>
					))}
				</div>

			</Body>
		</Main>


	);
}
export default SupperVision;
